import axios from "axios";
import store from "@/store";
import { Message } from "element-ui";
import router from '@/router'
// let router = import("@/router");

axios.defaults.baseURL = "/api";
//axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers["Cache-Control"] = "no-cache";
axios.defaults.headers["pragma"] = "no-cache";

let source = axios.CancelToken.source();

//请求添加token
axios.interceptors.request.use(request => {
    request.headers["x-auth-token"] = localStorage.getItem('token'); // 已将userId保存在store中
    request.url = "https://www.nuoli-agrotech.cn/api/" + request.url
    return request;
})

//切换页面取消请求
axios.interceptors.request.use(request => {
    request.cancelToken = source.token;
    return request;
});
// router.then(lib => {
//     lib.default.beforeEach((to, from, next) => {
//         source.cancel()
//         source = axios.CancelToken.source();
//         next()
//     })
// })

// 异常拦截处理器
const errorHandler = error => {
    if (error.response) {
        //   console.log(error.response)
        const data = error.response.data
        // 从 localstorage 获取 token
        // const token = storage.get(ACCESS_TOKEN)
        const token = localStorage.getItem('token')
        if (error.response.status === 401) {
            Message.warning('会话超时，请重新登录');
            router.push({ path: '/' })
            // 清除浏览器缓存
            localStorage.removeItem(token)
        } else {
            Message.warning(error.response.data)
        }
        //   if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
        //     notification.error({
        //       message: 'Unauthorized',
        //       description: 'Authorization verification failed'
        //     })
        //     if (token) {
        //       store.dispatch('Logout').then(() => {
        //         setTimeout(() => {
        //           window.location.reload()
        //         }, 1500)
        //       })
        //     }
        //   }
    }
    return Promise.reject(error)
}

//登录过期跳转
axios.interceptors.response.use(response => {
    let data = response.data;
    if (
        [10002].includes(data.ret)
    ) {
        router.then(lib => lib.default.push({ name: "login" })); // 跳转到登录页面
        Message.warning(data.msg);
    }
    return response;
}, errorHandler)

//返回值解构
axios.interceptors.response.use(response => {
    let data = response.status;
    if (response.headers['x-auth-token']) {
        let token = response.headers['x-auth-token']
        localStorage.setItem('token', token)
    }
    let isJson = (response.headers["content-type"] || "").includes("json");
    if (isJson) {
        if (data === 200) {
            return Promise.resolve({
                data: response.data,
                msg: data.statusText,
                code: data.status,
            });
        } else if (data === 401) {
            return Promise.resolve({
                data: response.data,
                msg: data.statusText,
                code: data.status,
            });
        } else {

        }
        return Promise.reject(
            data.msg ||
            "网络错误"
        );
    } else {
        return data;
    }
}, err => {
    // console.log(err)
    // let isCancel = axios.isCancel(err);
    // if (isCancel) {
    //     return new Promise(() => { });
    // }
    // return Promise.reject(
    //     err.response.data &&
    //     err.response.data.msg ||
    //     "网络错误"
    // );
})
const param = {
    baseURL: "api",
    Headers: {
        'Content-Type': 'multipart/form-data',
    }
}
export function post(url, data, otherConfig) {
    return axios.post(url, data, { ...otherConfig, ...param });
}

export function get(url, data, otherConfig) {
    return axios.get(url, data, { ...otherConfig, ...param });
}
export function put(url, data, otherConfig) {
    return axios.put(url, data, { ...otherConfig, ...param });
}